import type { PropsWithChildren } from "react";
import { Icon, type IconName } from "../icons";

/** Props Interface */
interface ComboboxButtonProps extends PropsWithChildren {
	iconName: IconName;
}

export function ComboboxButton({ children, iconName }: ComboboxButtonProps) {
	/** Render */
	return (
		<div className="h-stack">
			<Icon name={iconName} />
			<p>{children}</p>
		</div>
	);
}
